import { call, put, select, takeLatest } from 'redux-saga/effects'
import { NeuroConstants } from '../store/neuro.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getNeuroSelector } from '../selectors/getNeuro.selector'
import { getServiceIdSelector } from '../../../user/selectors'
import { INeuroState } from '../store/neuro.types'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { setNeuroResponse } from '../store/neuro.actions'
import { neuroPrAssess, neuroPrNabc, _featureRefKey } from '../store/neuro.reducers'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { wasPatientImmobilizedPrAssess } from '../wasPatientImmobilized/store/wasPatientImmobilized.reducers'
import { getWasPatientImmbobilizedSelector } from '../wasPatientImmobilized/selectors'
import { IWasPatientImmobilizedState } from '../wasPatientImmobilized/store/wasPatientImmobilized.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveNeuro() {
  const neuro: INeuroState = yield select(getNeuroSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const prNabcObj = getSelectedDataFromObject(neuro, Object.keys(neuroPrNabc))
  const prAssessNeuroObj: any = getSelectedDataFromObject(neuro, Object.keys(neuroPrAssess))
  const { neuroPrStrokeScale } = neuro

  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const prAssess = pcrDoc.prAssess ? [...pcrDoc.prAssess] : []
    const prAssessObjIndex = prAssess.findIndex((prAssObj) => prAssObj._featureRefKey === _featureRefKey)

    const wasPatientImmobilized: IWasPatientImmobilizedState = yield select(getWasPatientImmbobilizedSelector)

    const prAssessKeys: any = Object.keys(wasPatientImmobilizedPrAssess)
    const prAssessWasPtImmObj: any = getSelectedDataFromObject(wasPatientImmobilized, prAssessKeys)

    const prAssessobj = { ...prAssessNeuroObj, ...prAssessWasPtImmObj }

    if (prAssessObjIndex !== -1) {
      prAssess[prAssessObjIndex] = { ...prAssess[prAssessObjIndex], ...prAssessobj }
    } else {
      prAssess.push({ ...prAssessobj, _featureRefKey })
    }

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...prNabcObj,
      },
      prAssess: prAssess,
      prStrokeScale: [...neuroPrStrokeScale],
    }

    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setNeuroResponse(response))
    } catch (e) {
      yield put(throwPcrException(`saveNeuro() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveNeuroSaga() {
  yield takeLatest([NeuroConstants.SAVE_NEURO], performWithMutexHOG, saveNeuro)
}
